module.exports = __webpack_public_path__ + "img/wxpay@2x.db576024.png";